import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { ServiceCommissionsService } from '../services/service-commissions-.service';
import { AddCommissionsForServiceComponent } from './add-commissions-for-service/add-commissions-for-service.component';
import { EditCommissionsForServiceComponent } from './edit-commissions-for-service/edit-commissions-for-service.component';

@Component({
  selector: 'app-commissions-for-service',
  templateUrl: './commissions-for-service.component.html',
  styleUrls: ['./commissions-for-service.component.css']
})
export class CommissionsForServiceComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: AddCommissionsForServiceComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditCommissionsForServiceComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: ServiceCommissionsService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'unitName',
        header: 'Đơn vị quản lý',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'serviceProductCode',
        header: 'Mã dịch vụ sản phẩm',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'serviceProductName',
        header: 'Tên dịch vụ sản phẩm',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'measurementUnitName',
        header: 'Đơn vị tính',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      code: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };

    this._service
      .getListCommissionsForService(model)
      .then((res) => {
        if (res) {
          this.dataSource = res.data;
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editCommissionsForService(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
    this.pEdit.showPopup(model);
  }
  deleteCommissionsForService(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động danh mục hoa hồng theo dịch vụ này')
        .then((res) => {
          if (res) {
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }
  onAdd() {
    this.pCreate.showPopup();
  }

  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
